/*
 * Tampa Scents - Refundable Deposit for Home Scenting Plans
 * Config comes from snippets/deposit-policy.liquid (window.TampaDeposit).
 */
(function () {
  'use strict';
  var cfg = window.TampaDeposit;
  if (!cfg || !window.fetch) return;

  var DEP_ID = Number(cfg.depositVariantId);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);

  var state = { cart: null, hasDeposit: false, agreed: false };
  var syncing = false;
  var syncAgain = false;
  var syncTimer = null;
  var savePromise = null;

  /* ---------- helpers ---------- */
  function api(path, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(ROOT + path, opts).then(function (r) { return r.json(); });
  }

  function isService(item) {
    return cfg.serviceProductTypes.indexOf(item.product_type) > -1;
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || '');
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  /* ---------- watch every cart change made by the theme or apps ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (isCartMutation(url)) {
      p.then(function () { scheduleSync(); }, function () {});
    }
    return p;
  };

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 150);
  }

  /* ---------- keep the deposit line correct ---------- */
  function sync() {
    if (syncing) { syncAgain = true; return Promise.resolve(); }
    syncing = true;

    return api('cart.js')
      .then(function (cart) {
        var hasService = cart.items.some(isService);
        var deposits = cart.items.filter(function (i) { return i.variant_id === DEP_ID; });
        var updates = {};
        var action = null;

        if (hasService && deposits.length === 0) {
          action = api('cart/add.js', { items: [{ id: DEP_ID, quantity: 1 }] });
        } else if (hasService && (deposits.length > 1 || deposits[0].quantity !== 1)) {
          deposits.forEach(function (d, i) { updates[d.key] = i === 0 ? 1 : 0; });
          action = api('cart/update.js', { updates: updates });
        } else if (!hasService && deposits.length > 0) {
          deposits.forEach(function (d) { updates[d.key] = 0; });
          action = api('cart/update.js', { updates: updates, attributes: (function (a) { a[cfg.attributeName] = ''; return a; })({}) });
        }

        if (!action) { return { cart: cart, changed: false }; }
        return action
          .then(function () { return api('cart.js'); })
          .then(function (c) { return { cart: c, changed: true }; });
      })
      .then(function (res) {
        state.cart = res.cart;
        state.hasDeposit = res.cart.items.some(function (i) { return i.variant_id === DEP_ID; });
        var saved = res.cart.attributes && res.cart.attributes[cfg.attributeName];
        state.agreed = state.hasDeposit && !!saved;
        if (res.changed) return refreshUI();
      })
      .catch(function (e) { console.warn('[deposit]', e); })
      .then(function () {
        decorate();
        syncing = false;
        if (syncAgain) { syncAgain = false; scheduleSync(); }
      });
  }

  /* ---------- re-render the cart after we changed it ---------- */
  function refreshUI() {
    if (onCartPage()) {
      window.location.reload();
      return new Promise(function () {});
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') {
      return Promise.resolve();
    }
    var ids = [];
    drawer.getSectionsToRender().forEach(function (s) {
      if (ids.indexOf(s.section) === -1) ids.push(s.section);
    });
    return nativeFetch(ROOT + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try { drawer.renderContents({ sections: sections }); } catch (e) { console.warn('[deposit] render', e); }
      });
  }

  /* ---------- page decoration: lock the line, policy box, express buttons ---------- */
  function decorate() {
    document.documentElement.classList.toggle('has-deposit', state.hasDeposit);
    lockDepositLines();
    placePolicyBoxes();
    updateCheckoutButtons();
  }

  function lockDepositLines() {
    if (!state.cart) return;
    var keys = state.cart.items
      .filter(function (i) { return i.variant_id === DEP_ID; })
      .map(function (i) { return i.key; });

    var seeds = [];
    keys.forEach(function (key) {
      var sel = '[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]';
      seeds = seeds.concat(Array.prototype.slice.call(document.querySelectorAll(sel)));
    });
    seeds = seeds.concat(Array.prototype.slice.call(
      document.querySelectorAll('[data-quantity-variant-id="' + DEP_ID + '"], [data-product-id="' + DEP_ID + '"]')
    ));

    seeds.forEach(function (el) {
      var row = el.closest('li, tr, .cart-item, .cart__item') || el.parentElement;
      if (!row) return;
      row.querySelectorAll('quantity-input, cart-remove-button, main-cart-remove-button, main-cart-edit').forEach(function (c) {
        c.style.display = 'none';
        c.setAttribute('aria-hidden', 'true');
      });
      if (!row.querySelector('.deposit-locked-label')) {
        var label = document.createElement('span');
        label.className = 'deposit-locked-label';
        label.textContent = cfg.lockedLabel;
        var anchor = row.querySelector('quantity-input');
        if (anchor && anchor.parentElement) anchor.parentElement.appendChild(label);
        else row.appendChild(label);
      }
    });
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]')
    );
  }

  function placePolicyBoxes() {
    var tpl = document.getElementById('DepositPolicyTemplate');
    if (!state.hasDeposit) {
      document.querySelectorAll('[data-deposit-policy]').forEach(function (b) { b.remove(); });
      return;
    }
    if (!tpl) return;
    checkoutButtons().forEach(function (btn) {
      var anchor = btn.closest('form') || btn;
      var prev = anchor.previousElementSibling;
      if (prev && prev.hasAttribute('data-deposit-policy')) return;
      if (anchor.querySelector('[data-deposit-policy]')) return;
      anchor.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), anchor);
    });
    document.querySelectorAll('[data-deposit-agree]').forEach(function (cb) { cb.checked = state.agreed; });
  }

  function updateCheckoutButtons() {
    var block = state.hasDeposit && !state.agreed;
    checkoutButtons().forEach(function (btn) {
      btn.classList.toggle('deposit-checkout-blocked', block);
      if (block) btn.setAttribute('aria-disabled', 'true');
      else if (btn.getAttribute('aria-disabled') === 'true' && !btn.disabled) btn.removeAttribute('aria-disabled');
    });
  }

  function showError() {
    document.querySelectorAll('[data-deposit-policy]').forEach(function (box) {
      if (!box.offsetParent) return;
      box.classList.add('deposit-policy--invalid');
      var err = box.querySelector('[data-deposit-error]');
      if (err) { err.textContent = cfg.errorText; err.hidden = false; }
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function clearError() {
    document.querySelectorAll('[data-deposit-policy]').forEach(function (box) {
      box.classList.remove('deposit-policy--invalid');
      var err = box.querySelector('[data-deposit-error]');
      if (err) err.hidden = true;
    });
  }

  /* ---------- checkbox: save acceptance on the cart (shows on the order) ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-deposit-agree]')) return;
    state.agreed = e.target.checked;
    document.querySelectorAll('[data-deposit-agree]').forEach(function (cb) { cb.checked = state.agreed; });
    if (state.agreed) clearError();
    updateCheckoutButtons();

    var attrs = {};
    attrs[cfg.attributeName] = state.agreed ? 'Yes - ' + new Date().toISOString() : '';
    var p = api('cart/update.js', { attributes: attrs });
    savePromise = p;
    p.catch(function () {}).then(function () { if (savePromise === p) savePromise = null; });
  });

  /* ---------- block checkout until agreed ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
    if (!t || !state.hasDeposit) return;
    if (!state.agreed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
      return;
    }
    if (savePromise) {
      e.preventDefault();
      e.stopImmediatePropagation();
      savePromise.then(function () { t.click(); }, function () { t.click(); });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!state.hasDeposit || state.agreed) return;
    var s = e.submitter;
    var toCheckout = (s && s.name === 'checkout') || /\/checkout/.test(e.target.action || '');
    if (toCheckout) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  /* ---------- re-apply after the theme re-renders the cart ---------- */
  var decoTimer = null;
  new MutationObserver(function () {
    clearTimeout(decoTimer);
    decoTimer = setTimeout(decorate, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
